<div class="progress-loader" *ngIf="loading">
  <mat-progress-spinner [mode]="'indeterminate'" [diameter]="70" strokeWidth="2" style="margin-left: calc(100vw/2 - 38px);
  top: calc(100vh/2 - 55px);">
  </mat-progress-spinner>
</div>

